/**
 * @generated SignedSource<<531cd56309b57dd0733715286f0c25a9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StakingEventType = "REWARD" | "STAKE" | "UNSTAKE";
export type StakeInput = {
  assetAmount: any;
  assetId: string;
};
export type CreateStakeMutation$variables = {
  input?: StakeInput | null | undefined;
};
export type CreateStakeMutation$data = {
  readonly stake: {
    readonly id: string;
    readonly type: StakingEventType;
  } | null | undefined;
};
export type CreateStakeMutation = {
  response: CreateStakeMutation$data;
  variables: CreateStakeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Stake",
    "kind": "LinkedField",
    "name": "stake",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateStakeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateStakeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c6369f8bf48339003b298bcd40fc3812",
    "id": null,
    "metadata": {},
    "name": "CreateStakeMutation",
    "operationKind": "mutation",
    "text": "mutation CreateStakeMutation(\n  $input: StakeInput\n) {\n  stake(input: $input) {\n    id\n    type\n  }\n}\n"
  }
};
})();

(node as any).hash = "039dcc48008c8f02d327fd7a3f38dade";

export default node;
